import masonryTimerView from './masonryTimerView.html';

export default function masonryTimerComponent() {
	return {
		restrict: 'E',
		scope: {},
		bindToController: {
			label: '@',
			duration: '@',
			class: '@',
			callback: '&',
		},
		controllerAs: 'vm',
		controller: masonryTimerComponentCtrl,
		template: masonryTimerView,
	};
}

class masonryTimerComponentCtrl {
	constructor($interval) {
		'ngInject';
		this.$interval = $interval;
		this.timeLeft = this.duration;
		this.minutes;
		this.seconds;
		this.resetTimer();
		this.startCountdown();
	}

	resetTimer() {
		this.minutes = Math.floor(parseInt(this.duration, 10) / 60);
		this.seconds = parseInt(this.duration, 10) % 60;
	}

	startCountdown() {
		this.intv = this.$interval(() => {
			// if the time is up, reset the timer and fire the callback
			if (this.minutes === 0 && this.seconds === 0) {
				this.resetTimer();
				this.callback();
			}

			if (this.seconds === 0) {
				this.seconds = 59;
				this.minutes -= 1;
			} else {
				this.seconds -= 1;
			}

			this.timeLeft = this.minutes + ':' + this.zeroPad(this.seconds);
		}, 1000);
	}

	zeroPad(num) {
		if (num < 10) {
			num = '0' + num;
		}
		return num.toString();
	}
}
